/* Big Head PDP refinement: exact pilot; native variants, form and cart remain authoritative. */
(()=>{
'use strict';
const area=document.querySelector('[id^="ProductInfo-"]');
if(!area||!document.querySelector('.bh-product-name'))return;
document.documentElement.classList.add('bh-pdp-sharp');
function arrange(){
 const summary=area.querySelector('.gb-fit-summary');
 const form=area.querySelector('product-form');
 if(!summary||!form)return false;
 const buy=form.parentElement;
 buy.classList.add('bh-buy-block');
 if(buy.previousElementSibling!==summary)summary.after(buy);
 const offer=area.querySelector('.gb-offer');
 if(offer)buy.after(offer);
 const shipping=area.querySelector('.gb-shipping');
 if(shipping)(offer||buy).after(shipping);
 const help=area.querySelector('.gb-purchase-help');
 if(help)(shipping||offer||buy).after(help);
 const title=area.querySelector('.product__title');
 if(!area.querySelector('.bh-product-facts')){
  const facts=document.createElement('p');facts.className='bh-product-facts';facts.textContent='240 GSM · Heavy box cut';
  title.after(facts);
 }
 return true;
}
if(!arrange()){
 const observer=new MutationObserver(()=>{if(arrange())observer.disconnect();});
 observer.observe(area,{childList:true,subtree:true});
}
})();
